export default __webpack_public_path__ + "static/media/norwaygo-screenshot-06.20758133.png";